<template>
  <div class="report-page">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="back-btn" @click="$router.back()">
        <a-icon type="left" /> 返回
      </div>
      <h3>我要报事</h3>
    </div>

    <!-- 表单主体：整体白色背景 -->
    <div class="form-body">
      <a-form-model
          ref="modalForm"
          :model="formData"
          :rules="formRules"
          layout="vertical"
      >
        <!-- 1. 项目名称 -->
        <a-form-model-item label="项目名称" prop="monitorpointnum">
          <a-select
              :disabled="true"
              v-model="formData.monitorpointnum"
              placeholder="请选择项目"
              show-search
              :filter-option="filterOption"
              style="width: 100%"
          >
            <a-select-option v-for="(item, index) in monitorpointList" :key="index" :value="item.monitorpointnum">{{item.monitorpointname}}</a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- 2. 报事来源 & 报事类型 (并排) -->
        <div class="row-flex">
          <a-form-model-item label="报事来源" prop="order_source" class="flex-1">
            <a-select :disabled="true" v-model="formData.order_source" placeholder="请选择来源" allow-clear>
              <a-select-option value="自报">自报</a-select-option>
              <a-select-option value="调度中心">调度中心</a-select-option>
              <a-select-option value="外部报">外部报</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="报事类型" prop="repair_matter_type" class="flex-1">
            <a-select v-model="formData.repair_matter_type" placeholder="请选择类型" allow-clear>
              <a-select-option value="报事">报事</a-select-option>
              <a-select-option value="建议">建议</a-select-option>
              <a-select-option value="问询">问询</a-select-option>
              <a-select-option value="求助">求助</a-select-option>
              <a-select-option value="质疑">质疑</a-select-option>
              <a-select-option value="投诉">投诉</a-select-option>
            </a-select>
          </a-form-model-item>
        </div>

        <!-- 3. 联系人 & 联系电话 (并排) -->
        <div class="row-flex">
          <a-form-model-item label="报事人" prop="contacts" class="flex-1">
            <a-input v-model="formData.contacts" placeholder="请输入姓名" />
          </a-form-model-item>

          <a-form-model-item label="报事人手机号" prop="contact_information" class="flex-1">
            <a-input v-model="formData.contact_information" placeholder="请输入手机号码" />
          </a-form-model-item>
        </div>

        <!-- 4. 接报时间 -->
        <a-form-model-item label="报事时间" prop="receive_time">
          <a-date-picker
              v-model="formData.receive_time"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="请选择日期和时间"
              style="width: 100%"
          />
        </a-form-model-item>

        <!-- 5. 重大影响 & 是否困人 (并排) -->
        <div class="row-flex radio-group-wrapper">
          <a-form-model-item label="重大影响" prop="biginfluence" class="flex-1">
            <a-select v-model="formData.biginfluence" style="width: 100%">
              <a-select-option value="1">无</a-select-option>
              <a-select-option value="2">电梯困人</a-select-option>
              <a-select-option value="3">停用电梯</a-select-option>
              <a-select-option value="4">停电</a-select-option>
              <a-select-option value="5">发电</a-select-option>
              <a-select-option value="6">停水</a-select-option>
              <a-select-option value="7">跑水</a-select-option>
              <a-select-option value="8">意外伤害</a-select-option>
              <a-select-option value="9">治安</a-select-option>
              <a-select-option value="10">群访</a-select-option>
              <a-select-option value="11">传染病/疫情</a-select-option>
              <a-select-option value="12">火情</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="是否困人" prop="is_tiring" class="flex-1">
            <a-select v-model="formData.is_tiring" style="width: 100%">
              <a-select-option :value="0">否</a-select-option>
              <a-select-option :value="1">是</a-select-option>
            </a-select>
          </a-form-model-item>
        </div>

        <!-- 6. 详细内容 -->
        <a-form-model-item label="详细内容" prop="content">
          <a-textarea
              v-model="formData.content"
              placeholder="请详细描述问题情况，以便我们快速处理"
              :rows="4"
              class="custom-textarea"
          />
        </a-form-model-item>

        <!-- 7. 现场图片 -->
        <a-form-model-item label="现场图片" prop="picUrl">
          <a-upload
              name="fileList"
              :headers="uploadHeaders"
              list-type="picture-card"
              :data="uploadRepairsData"
              action="/thirdpart/upload"
              :file-list="picUrlList"
              :beforeUpload="beforeUpload"
              @preview="handlePreview"
              @change="picUrlUploaded">
            <div v-if="picUrlList.length < 3">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传图片</div>
            </div>
          </a-upload>
        </a-form-model-item>

        <a-form-model-item label="验证码" prop="code" style="margin-top: -15px">
          <div class="verify-code-wrapper">
            <a-input
                v-model.trim="formData.code"
                placeholder="请输入验证码"
                size="large"
                style="flex: 1;"
            >
              <a-icon slot="prefix" type="safety-certificate" style="color: #1890ff" />
            </a-input>
            <vertify-code ref="vertifyCode" @get-code="getVertifyCode" class="verify-code"></vertify-code>
          </div>
        </a-form-model-item>

        <!-- 8. 提交按钮 -->
        <div class="submit-btn-container">
          <a-button type="primary" block @click="confirm">提交报事</a-button>
        </div>

      </a-form-model>
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel" width="400px">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
    </div>
  </div>
</template>
<script>
import moment from "moment/moment";
import {mapGetters} from "vuex";
import {addRepairsOrder, commitRepairsOrderPic, getMonitorPointNameListByCondition,} from "A/thjlcx";
import VertifyCode from "C/VertifyCode.vue";
import compressFile from "@/json/compressor";

export default {
  name: 'ReportMatter',
  components: {VertifyCode},
  data() {
    return {
      fileList: [],
      formData: {
        monitorpointnum: '',
        order_num:'',
        order_type:'0',
        process_node: '',
        process_person: '',
        process_person_name: '',
        address: '',
        biginfluence: "1",
        is_tiring:0,
        need_finish_time: null,
        receive_time: null,
        content: '',
        contacts: '',
        contact_information: '',
        contacts_grade:'',
        contacts_evaluation:'',
        order_decs: '',
        fault: '',
        order_status:'',
        create_account: '',
        order_source:'外部报',
        repair_matter_type:'',
        is_postpone:'',
        is_plan_repair:'0',
        customer_evaluation:'否',
        whether_evaluate:'否',
        whether_check:'否',
        code:'',
      },
      formRules: {
        monitorpointnum: [{required: true, message: '请选择项目'}],
        order_type: [{required: true, message: '请选择工单类型'}],
        receive_time: [{required: true, message: '请选择接报时间'}],
        need_finish_time: [{required: true, message: '请选择计划完成的时间'}],
        content: [{required: true, message: '请填写工单具体内容'}],
        contacts: [{required: true, message: '请填写报事联系人'}],
        contact_information: [{required: true, message: '请填写报事联系方式'}],
        order_source: [{required: true, message: '请选择报事来源'}],
        repair_matter_type: [{required: true, message: '请选择报事类型'}],
        is_tiring: [{required: true, message: '请选择是否困人'}],
        // is_postpone: [{required: true, message: '请选择是否延期'}],
        //customer_evaluation: [{required: true, message: '请选择是否需要客户评价'}],
        code: [
          {required: true, message: '请输入验证码'},
          {
            validator: (rule, value, callback) => {
              if(value.toUpperCase() === this.vertifyCode.toUpperCase()) {
                callback();
              }else {
                callback('验证码错误')
              }
            }
          }
        ],
      },
      monitorpointList:[],
      vertifyCode: '',
      areacode:'',
      areaOptions: [],
      areaCascaderSelected:null,
      baseurl:'https://fda.u-lake.com/',
      previewVisible: false,
      previewImage: '',
      picUrlList:[],
      videoUrlList:[],
    };
  },
  computed: {
    ...mapGetters(['uploadHeaders', 'uploadRepairsData']),
  },
  watch: {
  },
  created() {
    this.formData.monitorpointnum=this.$store.state.monitorpointnum
    this.formData.receive_time = moment()
    this.getMonitorPointNameList()
  },
  methods: {
    getMonitorPointNameList(areacode) {
      getMonitorPointNameListByCondition({areacode:areacode,monitorpointnum: this.formData.monitorpointnum}).then(res => {
        if (res && res.returncode == '0') {
          this.monitorpointList = res.item
        } else {
          this.$message.error(res.errormsg)
        }
      })
    },
    getVertifyCode(vertifyCode) {
      this.vertifyCode = vertifyCode;
    },
    resetData() {
      this.picUrlList = []
      this.videoUrlList = []
      if (this.$refs.modalForm) {
        this.$refs.modalForm.resetFields();
      }
      this.$refs.vertifyCode.refreshCode();
    },
    confirm() {
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          this.formData.need_finish_time = this.formData.need_finish_time ? moment(this.formData.need_finish_time).format("YYYYMMDDHHmmss") : null
          this.formData.receive_time = this.formData.receive_time ? moment(this.formData.receive_time).format("YYYYMMDDHHmmss") : null
          this.formData.process_node = 10
          let params = {
            ...this.formData,
          };
          this.showLoading();
          addRepairsOrder(params).then(res => {
            this.hideLoading();
            if (res && res.returncode == '0') {
              this.$message.success('操作成功');
              this.$emit('get-operation-result', 'success', '操作成功');
              this.modalVisible = false;
              let pictypes = ""
              let picurls = ""
              let upload_time = ""
              for (let i = 0; i < this.picUrlList.length; i++) {
                pictypes = "1"
                if (i === this.picUrlList.length - 1) {
                  picurls += this.picUrlList[i].url
                  upload_time += moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
                } else {
                  picurls += this.picUrlList[i].url + ","
                  upload_time += moment(new Date()).format("YYYY-MM-DD HH:mm:ss") + ","
                }
              }
              if (this.picUrlList.length > 0 && this.videoUrlList.length > 0) {
                pictypes += "|2"
                picurls += "|" + this.videoUrlList[0].url
              } else if (this.videoUrlList.length) {
                pictypes += "2"
                picurls += this.videoUrlList[0].url
              }
              if (this.picUrlList.length > 0 || this.videoUrlList.length > 0) {
                let param = {
                  pictypes: pictypes,
                  picurls: picurls,
                  upload_time: upload_time + "| ",
                  monitorpointnum: this.formData.monitorpointnum,
                  order_id: res.order_id
                }
                commitRepairsOrderPic(param)
              }
              this.resetData()
              this.$router.back()
            } else {
              this.$message.error(res.errormsg || '操作失败');
            }
          })
        } else {
          this.$message.warning('请确认信息填写完整')
          return false;
        }
      })
    },
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    async handlePreview(file) {
      this.previewImage = this.baseurl+file.url;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async beforeUpload(file,info) {
      return compressFile(file);
    },
    picUrlUploaded(info) {
      let fileList = [...info.fileList];
      fileList = fileList.map(file => {
        if (file.response) {
          file.uid = "pic_urlid";
          file.url = file.response.urlPath;
        }
        return file;
      });
      this.picUrlList = fileList;
    },
    videoUrlUploaded(info) {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = file.response.urlPath;
        }
        return file;
      });
      this.videoUrlList = fileList;
    },
  },
};
</script>
<style scoped lang="scss">
.report-page {
  /* 整个页面背景设为浅灰，突出白色表单区域 */
  background-color: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 20px;
}

/* 顶部导航 */
.header {
  background: #fff;
  padding: 15px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05); /* 增加一点阴影区分层级 */

  .back-btn {
    color: #1890ff;
    font-size: 16px;
    cursor: pointer;
    margin-right: auto; /* 将标题推到中间 */
    display: flex;
    align-items: center;
  }

  h3 {
    margin: 0;
    font-weight: 600;
    color: #333;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 18px;
  }
}

/* 表单主体区域：全白背景 */
.form-body {
  background: #fff;
  margin: 10px; /* 距离边缘一点空隙 */
  padding: 20px 16px;
  border-radius: 8px;

  /* 核心修复：调整表单项间距 */
  ::v-deep .ant-form-item {
    margin-bottom: 5px; /* 缩小间距，默认是24px */
  }

  /* 核心修复：让错误提示文字不撑开高度，而是绝对定位或紧凑显示 */
  ::v-deep .ant-form-item-explain {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.2;
  }

  /* 输入框样式微调 */
  ::v-deep .ant-input,
  ::v-deep .ant-select-selector,
  ::v-deep .ant-calendar-picker {
    border-radius: 4px;
  }
}

/* 并排布局工具类 */
.row-flex {
  display: flex;
  justify-content: space-between;
  margin-bottom: -5px; /* 这一行整体的底部间距 */

  /* 让两个 item 之间有间隙 */
  ::v-deep .ant-form-item {
    flex: 1;
    margin-bottom: 0; /* 内部 item 不需要底部间距，由 row-flex 控制 */
  }

  .flex-1 {
    flex: 1;
  }

  .flex-1 + .flex-1 {
    margin-left: 12px; /* 两个并排项中间的间隙 */
  }
}

/* 针对单选框组的特殊处理，让它们看起来更紧凑 */
.radio-group-wrapper {
  ::v-deep .ant-radio-group {
    display: flex;
    gap: 15px;
  }
}

/* 文本域高度优化 */
.custom-textarea ::v-deep textarea {
  min-height: 100px !important; /* 强制最小高度 */
}

/* 图片上传样式 */
::v-deep .ant-upload-select-picture-card {
  width: 80px;
  height: 80px;
  margin-right: 8px;
  margin-bottom: 8px;
}

/* 验证码布局 */
.verify-code-wrapper {
  display: flex;
  gap: 10px;
  align-items: center;
}

.verify-code {
  width: 120px;
  height: 40px;
}

/* 提交按钮容器 */
.submit-btn-container {
  margin-top: 24px; /* 按钮距离上方内容的距离 */
}
</style>